import React, { useEffect, useState } from 'react';

export const Navbar = () => {
  const [scrolled, setScrolled] = useState(false);
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      const isScrolled = window.scrollY > 50;
      setScrolled(prev => {
        if (prev !== isScrolled) {
          return isScrolled;
        }
        return prev;
      });
    };
    window.addEventListener('scroll', handleScroll, { passive: true });
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const toggleMobileMenu = () => {
    setMobileMenuOpen(!mobileMenuOpen);
  };

  const closeMobileMenu = () => {
    setMobileMenuOpen(false);
  };

  return (
    <nav className="navbar" style={{ background: scrolled || mobileMenuOpen ? 'rgba(10, 10, 15, 0.95)' : 'rgba(10, 10, 15, 0.8)' }}>
      <div className="container nav-container">
        <div className="logo">
          <span className="logo-text">Lightning Send</span>
        </div>

        {/* Desktop Nav */}
        <div className="nav-links">
          <a href="#features">Features</a>
          <a href="#docs">Docs</a>
          <a href="#examples">Examples</a>
        </div>

        <div className="nav-actions">
          <a href="https://github.com/LucasFelinto/lightning-send" className="btn-primary-sm">GitHub</a>
        </div>

        {/* Mobile Menu Button */}
        <button className="mobile-menu-btn" onClick={toggleMobileMenu} aria-label="Toggle menu">
          {mobileMenuOpen ? (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><line x1="18" y1="6" x2="6" y2="18"></line><line x1="6" y1="6" x2="18" y2="18"></line></svg>
          ) : (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><line x1="3" y1="12" x2="21" y2="12"></line><line x1="3" y1="6" x2="21" y2="6"></line><line x1="3" y1="18" x2="21" y2="18"></line></svg>
          )}
        </button>
      </div>

      {/* Mobile Menu Overlay */}
      <div className={`mobile-menu ${mobileMenuOpen ? 'open' : ''}`}>
        <a href="#features" className="mobile-nav-link" onClick={closeMobileMenu}>Features</a>
        <a href="#docs" className="mobile-nav-link" onClick={closeMobileMenu}>Docs</a>
        <a href="#examples" className="mobile-nav-link" onClick={closeMobileMenu}>Examples</a>
        <a href="https://github.com/LucasFelinto/lightning-send" className="mobile-nav-link" onClick={closeMobileMenu}>GitHub</a>
      </div>
    </nav>
  );
};
